(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-df-header]');
    var subnav = document.querySelector('[data-df-subnav]');
    var menu = document.querySelector('[data-df-menu]');
    if (!header) return;
    var hero = document.querySelector('.df-hero');
    var root = document.documentElement;
    // Horizon scrolls .page-wrapper from 990px up and the window below that. Watch both.
    var wrapper = document.querySelector('.page-wrapper');
    function scrollTop() { return Math.max(wrapper ? wrapper.scrollTop : 0, window.scrollY || 0); }
    if (!hero) { root.classList.add('df-header-solid'); }

    function onScroll() {
      if (!hero) return;
      var trigger = hero.offsetTop + hero.offsetHeight - 84;
      var past = scrollTop() >= trigger;
      header.classList.toggle('is-past', past);
      subnav.classList.toggle('is-in', past);
      subnav.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    function openMenu() {
      menu.hidden = false;
      requestAnimationFrame(function () { menu.classList.add('is-open'); });
      document.querySelectorAll('[data-df-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      root.setAttribute('scroll-lock', '');
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      document.querySelectorAll('[data-df-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      root.removeAttribute('scroll-lock');
      setTimeout(function () { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 220);
    }
    document.querySelectorAll('[data-df-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
    document.querySelectorAll('[data-df-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) closeMenu(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-lineup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.df-lineup').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.df-chip');
      if (!chip) return;
      var card = chip.closest('.df-card');
      card.querySelectorAll('.df-chip').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      var img = card.querySelector('.df-card__img');
      if (img && chip.dataset.img) img.src = chip.dataset.img;
      var label = card.querySelector('.df-card__label');
      if (label) label.textContent = chip.dataset.label || '';
      if (chip.dataset.url) card.querySelectorAll('a.df-card__plate, a.df-card__name').forEach(function (l) { l.href = chip.dataset.url; });
      var pill = card.querySelector('.df-card__pill');
      if (pill) {
        if (chip.dataset.sold) {
          pill.textContent = 'Sold out'; pill.className = 'df-card__pill df-card__pill--soldout';
        } else {
          pill.textContent = pill.dataset.defaultText || ''; pill.className = 'df-card__pill df-card__pill--' + (pill.dataset.defaultKind || 'auto') + (pill.dataset.defaultText ? '' : ' is-empty');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-merch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.df-merch-gift').forEach((band) => {
    const cta = band.querySelector('[data-gift-cta]');
    const amts = [...band.querySelectorAll('[data-amt]')];
    if (!cta || !amts.length) return;
    const base = cta.getAttribute('href').split('?')[0];
    amts.forEach((b) => b.addEventListener('click', () => {
      amts.forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      cta.setAttribute('href', base + '?variant=' + b.dataset.variant);
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-straps"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-df-straps]').forEach(function (root) {
    if (root.dataset.dfStrapsReady) return;
    root.dataset.dfStrapsReady = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.df-straps__card'));
    var boxes = Array.prototype.slice.call(root.querySelectorAll('.df-straps__gbody input'));
    var filters = root.querySelector('[data-filters]'), scrim = root.querySelector('[data-scrim]');
    var fbtn = root.querySelector('[data-open]'), applied = root.querySelector('[data-applied]'), sortSel = root.querySelector('[data-sort]');
    var countWrap = root.querySelector('[data-count-wrap]'), countEl = root.querySelector('[data-count]'), totalEl = root.querySelector('[data-total]');
    var showN = root.querySelector('[data-show-n]'), fn = root.querySelector('[data-fn]'), empty = root.querySelector('[data-empty]');
    totalEl.textContent = cards.length;
    // A card may carry several values per group (data-fits="20 22"), so a value hits on any one of them.
    function has(c, k, v) { return (c.dataset[k] || '').split(' ').indexOf(v) !== -1; }
    function active() {
      var f = {};
      boxes.forEach(function (b) { if (b.checked) { (f[b.dataset.f] = f[b.dataset.f] || []).push(b.value); } });
      return f;
    }
    function matches(c, f, skip) {
      for (var k in f) {
        if (k === skip) continue;
        var hit = false;
        for (var i = 0; i < f[k].length; i++) { if (has(c, k, f[k][i])) { hit = true; break; } }
        if (!hit) return false;
      }
      return true;
    }
    function labelOf(b) { var s = b.parentElement.querySelectorAll('span'); return s[0].textContent; }
    function apply() {
      var f = active(), n = 0;
      cards.forEach(function (c) { var ok = matches(c, f); c.classList.toggle('is-hidden', !ok); if (ok) n++; });
      boxes.forEach(function (b) {
        var k = b.dataset.f, v = b.value, m = 0;
        cards.forEach(function (c) { if (has(c, k, v) && matches(c, f, k)) m++; });
        b.parentElement.querySelector('.df-straps__n').textContent = m;
        b.parentElement.classList.toggle('is-zero', m === 0 && !b.checked);
      });
      root.querySelectorAll('[data-val]').forEach(function (el) {
        var k = el.dataset.val, sel = boxes.filter(function (b) { return b.dataset.f === k && b.checked; });
        el.textContent = sel.length === 0 ? 'Any' : sel.length === 1 ? labelOf(sel[0]) : sel.length + ' selected';
      });
      applied.innerHTML = '';
      var fc = 0;
      boxes.forEach(function (b) {
        if (!b.checked) return;
        fc++;
        var chip = document.createElement('button'); chip.className = 'df-straps__chip'; chip.type = 'button';
        chip.innerHTML = '<span></span><i></i>';
        chip.firstChild.textContent = labelOf(b);
        chip.addEventListener('click', function () { b.checked = false; apply(); });
        applied.appendChild(chip);
      });
      countEl.textContent = n; countWrap.hidden = fc === 0;
      showN.textContent = n; fn.textContent = fc; fbtn.classList.toggle('has', fc > 0);
      empty.hidden = n !== 0;
      sort();
    }
    function sort() {
      var mode = sortSel.value;
      var order = cards.map(function (c, i) { return { c: c, i: i }; });
      order.sort(function (a, b) {
        if (mode === 'price-asc') return ((+a.c.dataset.price || 1e9) - (+b.c.dataset.price || 1e9)) || (a.i - b.i);
        if (mode === 'price-desc') return ((+b.c.dataset.price || 0) - (+a.c.dataset.price || 0)) || (a.i - b.i);
        return ((+a.c.dataset.ord) - (+b.c.dataset.ord)) || (a.i - b.i);
      });
      order.forEach(function (o, idx) { o.c.style.order = idx; });
    }
    function openDrawer(o) {
      filters.classList.toggle('is-open', o); scrim.classList.toggle('is-open', o);
      document.documentElement.style.overflow = o ? 'hidden' : '';
    }
    boxes.forEach(function (b) { b.addEventListener('change', apply); });
    // ?fits=22mm from a watch page pre-selects that lug width.
    try { var want = (new URLSearchParams(location.search).get('fits') || '').replace(/mm/i, ''); if (want) boxes.forEach(function (b) { if (b.dataset.f === 'fits' && b.value === want) b.checked = true; }); } catch (e) {}
    sortSel.addEventListener('change', sort);
    fbtn.addEventListener('click', function () { openDrawer(true); });
    scrim.addEventListener('click', function () { openDrawer(false); });
    root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', function () { openDrawer(false); }); });
    root.querySelectorAll('[data-clear]').forEach(function (el) { el.addEventListener('click', function () { boxes.forEach(function (b) { b.checked = false; }); apply(); }); });
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-df-wall]').forEach(function (root) {
    if (root.dataset.dfWallReady) return;
    root.dataset.dfWallReady = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.df-wall__card'));
    var boxes = Array.prototype.slice.call(root.querySelectorAll('.df-wall__gbody input'));
    var filters = root.querySelector('[data-filters]'), scrim = root.querySelector('[data-scrim]');
    var fbtn = root.querySelector('[data-open]'), applied = root.querySelector('[data-applied]'), sortSel = root.querySelector('[data-sort]');
    var countWrap = root.querySelector('[data-count-wrap]'), countEl = root.querySelector('[data-count]'), totalEl = root.querySelector('[data-total]');
    var showN = root.querySelector('[data-show-n]'), fn = root.querySelector('[data-fn]'), empty = root.querySelector('[data-empty]');
    var RANK = { stock: 0, pre: 1, soon: 2, out: 3 };
    totalEl.textContent = cards.length;
    function active() {
      var f = {};
      boxes.forEach(function (b) { if (b.checked) { (f[b.dataset.f] = f[b.dataset.f] || []).push(b.value); } });
      return f;
    }
    function matches(c, f, skip) {
      for (var k in f) { if (k !== skip && f[k].indexOf(c.dataset[k]) === -1) return false; }
      return true;
    }
    function labelOf(b) { var s = b.parentElement.querySelectorAll('span'); return s[0].textContent; }
    function apply() {
      var f = active(), n = 0;
      cards.forEach(function (c) { var ok = matches(c, f); c.classList.toggle('is-hidden', !ok); if (ok) n++; });
      boxes.forEach(function (b) {
        var k = b.dataset.f, v = b.value, m = 0;
        cards.forEach(function (c) { if (c.dataset[k] === v && matches(c, f, k)) m++; });
        b.parentElement.querySelector('.df-wall__n').textContent = m;
        b.parentElement.classList.toggle('is-zero', m === 0 && !b.checked);
      });
      root.querySelectorAll('[data-val]').forEach(function (el) {
        var k = el.dataset.val, sel = boxes.filter(function (b) { return b.dataset.f === k && b.checked; });
        el.textContent = sel.length === 0 ? (k === 'avail' ? 'All' : 'Any') : sel.length === 1 ? labelOf(sel[0]) : sel.length + ' selected';
      });
      applied.innerHTML = '';
      var fc = 0;
      boxes.forEach(function (b) {
        if (!b.checked) return;
        fc++;
        var chip = document.createElement('button'); chip.className = 'df-wall__chip'; chip.type = 'button';
        chip.innerHTML = '<span>' + labelOf(b) + '</span><i></i>';
        chip.addEventListener('click', function () { b.checked = false; apply(); });
        applied.appendChild(chip);
      });
      countEl.textContent = n; countWrap.hidden = fc === 0;
      showN.textContent = n; fn.textContent = fc; fbtn.classList.toggle('has', fc > 0);
      empty.hidden = n !== 0;
      sort();
    }
    function sort() {
      var mode = sortSel.value;
      var order = cards.map(function (c, i) { return { c: c, i: i }; });
      order.sort(function (a, b) {
        if (mode === 'stock') return (RANK[a.c.dataset.avail] - RANK[b.c.dataset.avail]) || (a.i - b.i);
        if (mode === 'price-asc') return ((+a.c.dataset.price || 1e9) - (+b.c.dataset.price || 1e9)) || (a.i - b.i);
        if (mode === 'price-desc') return ((+b.c.dataset.price || 0) - (+a.c.dataset.price || 0)) || (a.i - b.i);
        return a.i - b.i;
      });
      order.forEach(function (o, idx) { o.c.style.order = idx; });
    }
    function openDrawer(o) {
      filters.classList.toggle('is-open', o); scrim.classList.toggle('is-open', o);
      document.documentElement.style.overflow = o ? 'hidden' : '';
    }
    boxes.forEach(function (b) { b.addEventListener('change', apply); });
    sortSel.addEventListener('change', sort);
    fbtn.addEventListener('click', function () { openDrawer(true); });
    scrim.addEventListener('click', function () { openDrawer(false); });
    root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', function () { openDrawer(false); }); });
    root.querySelectorAll('[data-clear]').forEach(function (el) { el.addEventListener('click', function () { boxes.forEach(function (b) { b.checked = false; }); apply(); }); });
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
